import AdminServerActionCreators from '../actions/AdminServerActionCreators';
import SessionStore from '../stores/SessionStore';
import Constants from '../constants/AdminConstants';
import client from './rest/AdminClient';
import assign from 'object-assign';
import qs from 'qs';
const api1 = 'api/1/';
const api2 = 'api/2';
const ajax = {
    get: function (url) {
        return client({
            method: 'GET',
            path: url
        });
    },
    method: function (method, url, data) {
        return client({
            method: method.toUpperCase(),
            path: url,
            entity: JSON.stringify(data)
        });
    }
};
const isAdminUser = () => {
    return SessionStore.hasAdminRole();
};
const isTarriffUser = () => {
    return SessionStore.hasTariffRole();
};
export function getTariffs() {
    return ajax.get(api1 + 'tariffs')
        .then(function (res) {
        AdminServerActionCreators.receiveTariffs(res.entity.tariffs);
        return res;
    })
        .catch(function (err) {
        console.log(err.stack || err);
    });
}
;
export function getTariff(id) {
    return ajax.get(api1 + 'tariffs/' + id)
        .then(function (res) {
        AdminServerActionCreators.receiveTariff(res.entity);
        return res;
    })
        .catch(function (err) {
        console.log(err.stack || err);
    });
}
;
export function addTariff(tariff) {
    return (isAdminUser() || isTarriffUser()) ?
        ajax.method('post', api1 + 'tariffs', tariff)
            .then(function (res) {
            AdminServerActionCreators.receiveAddTariffSuccess(res.entity);
            return res;
        })
            .catch(function (err) {
            console.log(err.stack || err);
        })
        : null;
}
;
export function updateTariff(tariff, password) {
    var entity = { tariff: tariff, password: password };
    return (isAdminUser() || isTarriffUser()) ?
        ajax.method('patch', api1 + 'tariffs/' + tariff._id, entity)
            .then(function (res) {
            AdminServerActionCreators.receiveUpdateTariffSuccess(res.entity);
            return res;
        })
            .catch(function (err) {
            console.log(err.stack || err);
            AdminServerActionCreators.receiveUpdateTariffFail(err);
        })
        : null;
}
;
export function removeTariff(tariff, password) {
    var path = api1 + 'tariffs/' + tariff._id;
    var entity = JSON.stringify({ password: password });
    (isAdminUser() || isTarriffUser()) ?
        client({ method: 'DELETE', path: path, entity: entity })
            .then(function (res) {
            AdminServerActionCreators.receiveRemoveTariffSuccess(tariff);
        })
            .catch(function (err) {
            console.log(err.stack || err);
            AdminServerActionCreators.receiveRemoveTariffFail(err);
        })
        : null;
}
;
export function getTariffsUsage() {
    return ajax.get(`${api2}/tariffs/usage`)
        .then(function (res) {
        AdminServerActionCreators.receiveGetTariffsUsage(res);
        return res;
    })
        .catch(function (err) {
        console.log(err.stack || err);
    });
}
;
